import { UserRequest, UserRequestTouched } from "../types/users";

export const USER_DEFAULTS: UserRequest = {
  email: "",
  firstName: "",
  lastName: "",
  phone: "",
  password: "",
  schedule: [],
  skills: [],
  userType: 0,
};

export const USER_TOUCHED_DEFAULTS: UserRequestTouched = {
  firstNameTouched: false,
  lastNameTouched: false,
  passwordTouched: false,
  emailTouched: false,
};
